module.exports = __webpack_public_path__ + "static/media/Latios_gaussian2.283751a3.png";